angular.module('unica_material.material_controllers', [])

.controller('MaterialBasicController',
	function(
		$rootScope, $scope, $stateParams,
		FileUploader, getBaseApiURL, Session,
		MaterialDeleteService
	) {

	$scope.forms = {};

	$scope.uploader =  new FileUploader({
		removeAfterUpload: true,
		alias: 'files',
		url: getBaseApiURL + '/event/upload-material',
		headers: {
			Authorization : 'Bearer ' + Session.token,
			Accept: 'application/json'
		}
	});

	$rootScope.materialData = {
		event_id: $stateParams.event_id,
		files: []
	};

	$scope.deleteWorkshopMaterial = function( materialId ) {
		$scope.showLoader();
		MaterialDeleteService
			.deleteMaterial( materialId )
			.then(function(data) {
				$scope.hideLoader();

				$rootScope.materialData = data;
				//$scope.showSuccessMsg('Materiale Workshop rimosso con successo!', '');
			});
	};

});


